import {
  CompanyTypeV3,
  QuestionEmployeeCount,
  SalesVolumeV3,
} from "../../../../../types/brex-api";
// whitelisted refcode for offline events.
/**
 * We generate a new signup page per event from the list below
 */
export const salesRepRefCodes = [
  "mok",
  "jchang",
  "jimmy",
  "shai",
  "wenger",
  "conor",
  "gaby",
  "michael",
  "jeanine",
  "billy",
  "samantha",
  "chesley",
  "lauren",
  "triantos",
  "joel",
  "kasteler",
  "reena",
  "elena",
  "reed",
];

export const salesRepNameMapper = {
  mok: "Jason Mok",
  jchang: "Jonathan Chang",
  jimmy: "Jimmy Stephens",
  shai: "Shai Goldman",
  wenger: "Erica Wenger",
  conor: "Conor Bradshaw",
  gaby: "Gaby Levey",
  michael: "Michael Morgenstern",
  jeanine: "Jeanine Suah",
  billy: "Billy Hahn",
  samantha: "Samantha Parkman",
  chesley: "Chesley McLeary",
  lauren: "Lauren Cristodero",
  triantos: "Thomas Triantos",
  joel: "Joel Minnich",
  kasteler: "Sam Kasteler",
  reena: "Reena Mahil",
  elena: "Elena Pesci",
  reed: "Reed Macdonald",
};

export const isTechEvent = (refCode: string) => {
  return salesRepRefCodes.includes(refCode);
};

export const isTechEventUrl = (pathname: string) => {
  const refCodePath = getRefCodeFromUrl(pathname);
  return isTechEvent(refCodePath);
};

export const getRefCodeFromUrl = (pathname: string) => {
  const paths = pathname?.split("/");
  const refCodePath = paths?.[2];
  return refCodePath;
};

export const isOldEECountEnumType = (employeeCount) => {
  if (employeeCount == null) {
    return false;
  }
  if (
    employeeCount === QuestionEmployeeCount.FIFTY_ONE_TO_ONE_HUNDRED ||
    employeeCount ===
      QuestionEmployeeCount.FIVE_HUNDRED_ONE_TO_TWO_THOUSAND_FIVE_HUNDRED ||
    employeeCount ===
      QuestionEmployeeCount.MORE_THAN_TWO_THOUSAND_FIVE_HUNDRED ||
    employeeCount === QuestionEmployeeCount.ONE_HUNDRED_ONE_TO_FIVE_HUNDRED
  ) {
    return true;
  }
  return false;
};

export const isOldSalesVolume = (monthlySales) => {
  if (!monthlySales) {
    return false;
  }

  return (
    monthlySales !== SalesVolumeV3.UNDER_FOUR_HUNDRED_K &&
    monthlySales !== SalesVolumeV3.FOUR_HUNDRED_K_TO_ONE_MM &&
    monthlySales !== SalesVolumeV3.ONE_MM_TO_TWELVE_MM &&
    monthlySales !== SalesVolumeV3.MORE_THAN_TWELVE_MM
  );
};

export const isOldCompanyType = (companyType) => {
  if (!companyType) {
    return false;
  }

  return (
    companyType !== CompanyTypeV3.ECOMMERCE &&
    companyType !== CompanyTypeV3.OTHER
  );
};
